import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { EmptyState } from '../admin/EmptyState.jsx';
import { Button } from '../ui/Button.jsx';
import { usePermissions } from '../../hooks/usePermissions.js';

/**
 * Hiding a nav item is not enough — the URL is still typeable. This turns a
 * would-be 403 into an explanation.
 */
export const RequirePermission = ({ permission }) => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  if (permissions[permission]) return <Outlet />;

  return (
    <div className="rounded-lg border border-beam-blue/10 bg-white shadow-sm">
      <EmptyState
        icon={ShieldAlert}
        title={t('admin.noAccessTitle')}
        description={t('admin.noAccessBody', {
          role: t(`admin.role_${permissions.role}`, { defaultValue: permissions.role }),
        })}
        action={
          <Button to="/admin" variant="outline">
            {t('admin.backToDashboard')}
          </Button>
        }
      />
    </div>
  );
};
